'use client';
import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import ResetPasswordForm from '../components/resetPasswordForm';
import useTranslation from '../../lib/i18n/useTranslation';
export default function ResetPasswordPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { t } = useTranslation();
  return (
    <>
     <Flex
        p={3}
        maxW={350}
        flexDirection={"column"}
      >
        <Text
          fontSize={"18px"}
          >{t('auth.resetPassword')}</Text>
        <Text mb={2} textStyle="subtitle">{t('auth.resetPasswordDesc')}</Text>
        <ResetPasswordForm email={searchParams.get('email')} />
        <Link to="/auth/sign-in">
              <Button
                variant="coralTransparent"
                mt={3}
                textAlign={'center'}
                p={0}
              >
             {t('auth.goBackToSignIn')}
            </Button>
          </Link>
     </Flex>
    </>
  )
}
